import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';

import { FileUploadService } from './file-upload.service';
import { DEFAULT_AVATAR } from '../components/profile-image-editor/profile-image-editor.component';

@Injectable({ providedIn: 'root' })
export class ProfileImageService {
  private fileUploadService = inject(FileUploadService);

  /** Gespeicherter MinIO-Key → frische presigned URL; ohne Key oder bei Fehler das Default-Avatar */
  resolve(key?: string | null): Observable<string> {
    if (!key) {
      return of(DEFAULT_AVATAR);
    }

    return this.fileUploadService.getPresignedUrl(key).pipe(
      catchError((err) => {
        // Kein Toast: ein fehlendes Avatar soll den Nutzer nicht behelligen. Ohne diese
        // Ausgabe verschluckt der Fallback aber jeden Serverfehler spurlos.
        console.warn('Profilbild konnte nicht aufgelöst werden:', err);
        return of(DEFAULT_AVATAR);
      }),
    );
  }
}
